export const resellerReducer = (
  state = {
    loading: false,
    resellerList: null,
    resellerView: null,
    vrTransactionList: null,
    error: null,
  },
  action
) => {
  switch (action.type) {
    // RESELLER LIST
    case "GET_RESELLER_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_RESELLER_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        resellerList: action.payload,
        error: null,
      };

    case "GET_RESELLER_LIST_FAILED":
      return {
        ...state,
        loading: false,
        resellerList: null,
        error: action.payload,
      };

    // RESELLER VIEW
    case "GET_RESELLER_LIST_VIEW_REQUEST":
      return {
        ...state,
        loading: true,
        resellerView: null,
        error: null,
      };

    case "GET_RESELLER_LIST_VIEW_SUCCESS":
      return {
        ...state,
        loading: false,
        resellerView: action.payload,
        error: null,
      };

    case "GET_RESELLER_LIST_VIEW_FAILED":
      return {
        ...state,
        loading: false,
        resellerView: null,
        error: action.payload,
      };

    // VR TRANSACTION LIST
    case "GET_VR_TRANSACTION_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };

    case "GET_VR_TRANSACTION_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        vrTransactionList: action.payload,
        error: null,
      };

    case "GET_VR_TRANSACTION_LIST_FAILED":
      return {
        ...state,
        loading: false,
        vrTransactionList: null,
        error: action.payload,
      };

    default:
      return state;
  }
};